import { Children, memo } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../theming/contexts/ThemeContext';
import { defaultTheme } from '../../theming/model/Theme';
import { jsx as _jsx } from "react/jsx-runtime";
const PaddedArea = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PaddedArea"
})(["padding:", ";"], ({
  $contentPadding
}) => $contentPadding);
export const PrimaryMessageContentSectionWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PrimaryMessageContentSectionWrapper"
})(["overflow:hidden;width:100%;button{width:auto;}"]);
const PrimaryMessageContentSection = /*#__PURE__*/memo(({
  children,
  className
}) => {
  const {
    contentPadding = defaultTheme.contentPadding
  } = useTheme();
  const hasContent = Children.count(children) > 0;
  if (!hasContent) {
    return null;
  }
  return /*#__PURE__*/_jsx(PrimaryMessageContentSectionWrapper, {
    "data-test-id": "primary-message-content-section",
    className: className,
    children: /*#__PURE__*/_jsx(PaddedArea, {
      $contentPadding: contentPadding,
      children: children
    })
  });
});
PrimaryMessageContentSection.displayName = 'PrimaryMessageContentSection';
export default PrimaryMessageContentSection;